export const CONTEXT_OPTIONS = [
  {
    key: "DOSSIER",
    name: "Dossier",
  },
  {
    key: "DOSSIER-CHECKIN",
    name: "Dossier checkin",
  },
  {
    key: "DOSSIER-CHECKOUT",
    name: "Dossier checkout",
  },
  {
    key: "DRIVE",
    name: "Drive",
  },
  {
    key: "DRIVE-CHECKIN",
    name: "Drive checkin",
  },
  {
    key: "DRIVE-CHECKOUT",
    name: "Drive checkout",
  },
];

export const ViewMode = {
  EDIT: 0,
  PREVIEW: 1,
}
